<template>
  <div class="ce-wrapper">
    <div v-if="editMode" :class="'ce ce-' + content.type + ' ce-edit-mode'">
      <div class="edit-header d-flex align-items-center">
        <h5 class="mb-0">
          <span class="text-success"><i class="fas fa-list-ul"></i></span>
          Länklista, artiklar
        </h5>
        <CeButtonGroup
          v-on:on-remove-click="onRemoveClick"
          v-on:on-arrow-up-click="onArrowUp"
          v-on:on-arrow-down-click="onArrowDown"
        />
      </div>
      <b-form-group
        label="Rubrik"
        :for="'ceListArticlesHeadline' + content.id"
        label-sr-only
      >
        <b-form-input
          :value="content.headline"
          @change="updateHeadline"
          id="headline"
          placeholder="Rubrik för listan... (valfritt)"
        ></b-form-input>
        <!-- <b-form-input :value="content.headline" :id="'ceListArticlesHeadline'+content.id" placeholder="Skriv en rubrik..."></b-form-input> -->
      </b-form-group>

      <b-form-group>
        <b-button @click="selectWindowOpen = true" variant="success" size="sm">
          Lägg till artiklar <i class="fas fa-plus"></i>
        </b-button>
      </b-form-group>

      <b-form-group>
        <div class="ce-list">
          <div
            v-for="(article, index) in filteredSelectedArticles"
            :key="article.id"
            class="ce-list-item"
          >
            <div class="ce-list-item-prefix">
              <figure>
                <img
                  v-if="article.feature_image"
                  :src="article.feature_image ? articleImageList[index] : ''"
                />
              </figure>
            </div>
            <div class="ce-list-item-desc">
              <h6 class="mb-0">{{ article.title }}</h6>
            </div>
            <div class="ce-list-item-action">
              <b-button
                @click="removeArticle(article.id)"
                variant="flat-primary"
                size="sm"
                class="ml-auto"
                ><i class="fas fa-trash"></i
              ></b-button>
            </div>
          </div>
        </div>
      </b-form-group>
    </div>

    <div v-else :class="'ce ce-' + content.type">
      <h3 v-if="content.headline" class="ce-headline mb-1">
        {{ content.headline }}
      </h3>
      <div class="ce-list">
        <div
          v-for="(article, index) in filteredSelectedArticles"
          :key="article.id"
          class="ce-list-item"
        >
          <div class="ce-list-item-prefix">
            <figure>
              <img
                v-if="article.feature_image"
                :src="article.feature_image ? articleImageList[index] : ''"
              />
            </figure>
          </div>
          <div class="ce-list-item-desc">
            <h6 class="mb-0">{{ article.title }}</h6>
          </div>
          <div class="ce-list-item-action">
            <b-button
              @click="reRouteToArticle(article.id)"
              variant="primary"
              size="sm"
              >Visa</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="modal-select-articles"
      centered
      title="Välj artiklar"
      ok-only
      size="lg"
      v-model="selectWindowOpen"
      @close="cancelAddingArticles"
      :no-close-on-esc="true"
      :no-close-on-backdrop="true"
    >
      <b-card-text>
        <SelectArticles
          @selectedArticlesUpdated="updateSelectedArticles($event)"
          :currentArticles="getTempArticles"
        ></SelectArticles>
      </b-card-text>
      <template #modal-footer>
        <b-button variant="success" @click="addArticles">
          Lägg till markerade
        </b-button>
        <b-button variant="secondary" @click="cancelAddingArticles">
          Avbryt
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BButton, BFormInput, BCardText, BFormGroup } from "bootstrap-vue";
import CeButtonGroup from "@/components/Article/ContentElements/CeButtonGroup";
import ContentElementButtonGroupMixin from "@/models/mixins/ContentElementButtonGroupMixin";
import { createNamespacedHelpers, mapGetters } from "vuex";
import SelectArticles from "@/components/SelectArticles.vue";
import axios from "axios";
const { mapActions } = createNamespacedHelpers("editArticle");

export default {
  name: "CeListArticles",
  mixins: [ContentElementButtonGroupMixin],
  props: {
    content: {},
    editMode: Boolean,
  },
  components: {
    BButton,
    BFormGroup,
    BFormInput,
    CeButtonGroup,
    BCardText,
    SelectArticles,
  },
  data() {
    return {
      selectWindowOpen: false,
      tempArticles: [],
      selectedArticleIds: [],
      oldArticles: [],
      thumbProps: {
        blank: true,
        blankColor: "#ccc",
        width: 64,
        height: 64,
      },
      articleImageList: [],
    };
  },
  async mounted() {
    this.tempArticles = this.content.items ?? [];
    this.selectedArticleIds = this.content.items ?? [];
    this.oldArticles = this.content.items ?? [];
    for (let i = 0; i < this.filteredSelectedArticles.length; i++) {
      if (this.filteredSelectedArticles[i].feature_image) {
        this.articleImageList.push(
          await this.fetchImageWithToken(
            this.filteredSelectedArticles[i].feature_image.original
          )
        );
      }
    }
  },
  watch: {
    async filteredSelectedArticles(newArticles) {
      this.articleImageList = [];
      for (let i = 0; i < newArticles.length; i++) {
        if (newArticles[i].feature_image) {
          this.articleImageList.push(
            await this.fetchImageWithToken(
              newArticles[i].feature_image.original
            )
          );
        } else {
          this.articleImageList.push(null);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["getAllArticles", "getArticleById"]),
    getArticles: function () {
      return this.getAllArticles();
    },
    filteredSelectedArticles: function () {
      return this.getAllArticles.filter((a) =>
        this.tempArticles.includes(a.id)
      );
    },
    getTempArticles: function () {
      return this.tempArticles;
    },
  },
  methods: {
    async fetchImageWithToken(imageUrl) {
      try {
        const token = JSON.parse(localStorage.getItem("user")).jwt;

        const response = await axios.get(imageUrl, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          responseType: "blob",
        });

        // use the set $ to upade the imageUrls
        return URL.createObjectURL(response.data);
      } catch (error) {
        return "";
      }
    },
    ...mapActions(["updateContent", "uploadContentItems"]),
    updateHeadline: function (headline) {
      let content = this.content;
      content.headline = headline;
      this.updateContent(content);
    },
    reRouteToArticle: function (articleID) {
      const article = this.fetchArticleById(articleID);
      this.$router.push({
        name: "article-details",
        params: { id: articleID, alias: article.title },
      });
    },
    addArticles: function () {
      this.oldArticles = this.selectedArticleIds;
      this.selectWindowOpen = false;
    },
    cancelAddingArticles: function () {
      this.selectWindowOpen = false;
      this.selectedArticleIds = this.oldArticles;
      this.updateList(this.selectedArticleIds);
    },
    updateSelectedArticles: function (articles) {
      this.oldArticles = articles.oldArticles;
      this.selectedArticleIds = articles.newArticles;
      this.updateList(articles.newArticles);
    },
    updateList(selectedArticleIds) {
      let content = this.content;
      content.items = selectedArticleIds;
      this.tempArticles = selectedArticleIds;

      this.uploadContentItems(content);
    },
    fetchArticleById: function (articleID) {
      if (!articleID) return;

      return this.getArticleById(articleID);
    },
    removeArticle: function (articleID) {
      if (!articleID) return;

      this.selectedArticleIds.splice(
        this.selectedArticleIds.indexOf(articleID),
        1
      );
      this.updateList(this.selectedArticleIds);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/variables/_variables.scss";
.ce-list-item {
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-bottom: 1px solid #ebe9f1;
}
.ce-list-item:last-child {
  border-bottom: none;
}
.ce-list-item-prefix {
  padding: 0.75rem 0;
}
.ce-list-item-prefix figure {
  margin: 0;
  width: 4rem;
  height: 4rem;
  background-color: #82868b;
}
.ce-list-item-prefix figure img {
  width: 4rem;
  height: 4rem;
  object-fit: cover;
}
.ce-list-item-desc {
  padding: 0.75rem 0 0.75rem 0.75rem;
}
.ce-list-item-action {
  padding: 0.75rem 0;
}
.ce-list-item-desc {
  margin-right: auto;
}
</style>
